"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperSidebarContextProvider = exports.WrapperSidebarContext = void 0;

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var WrapperSidebarContext = /*#__PURE__*/(0, _react.createContext)();
exports.WrapperSidebarContext = WrapperSidebarContext;

var WrapperSidebarContextProvider = _ref => {
  var {
    session,
    permisos,
    data,
    logout,
    redirectTo,
    children
  } = _ref;
  var [isInMobile, setIsInMobile] = (0, _react.useState)(false);
  var [isSidebarOpen, setIsSidebarOpen] = (0, _react.useState)(false);
  var [currentPathname, setCurrentPathname] = (0, _react.useState)("");

  var hasPermiso = nroPermiso => {
    return !!permisos[nroPermiso];
  };

  var animateSidebarSwipe = () => {
    var $sidebar = document.querySelector('#sidebar');
    $sidebar.style.transform = isSidebarOpen ? "translateX(-100%)" : "translateX(0)";
  };

  var animateBurguerMenu = () => {
    var firstLine = document.querySelector('#burguer-menu__line-1');
    var secondLine = document.querySelector('#burguer-menu__line-2');
    var thirdLine = document.querySelector('#burguer-menu__line-3');
    firstLine.style.transform = isSidebarOpen ? "rotate(0deg) translateY(0)" : "rotate(45deg) translateY(.8rem)";
    secondLine.style.display = isSidebarOpen ? "inline" : "none";
    thirdLine.style.transform = isSidebarOpen ? "rotate(0deg) translateY(0)" : "rotate(-45deg) translateY(-.8rem)";
  };

  var toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    animateSidebarSwipe();
    animateBurguerMenu();
  };

  (0, _react.useEffect)(() => {
    setIsInMobile(window.innerWidth <= 480);
  }, []);
  return /*#__PURE__*/_react.default.createElement(WrapperSidebarContext.Provider, {
    value: {
      session,
      permisos,
      accordionItems: data,
      isInMobile,
      currentPathname,
      isSidebarOpen,
      logout,
      redirectTo,
      setCurrentPathname,
      setIsSidebarOpen,
      hasPermiso,
      toggleSidebar,
      animateBurguerMenu
    }
  }, children);
};

exports.WrapperSidebarContextProvider = WrapperSidebarContextProvider;